var metric, imperial;

metric = {
  'mW/cm²': {
    name: {
      singular: 'milliwatt per square centimeter',
      plural: 'milliwatts per square centimeter',
    },
    to_anchor: 1,
  },
  'μW/cm²': {
    name: {
      singular: 'microwatt per square centimeter',
      plural: 'microwatts per square centimeter',
    },
    to_anchor: 0.001,
  },
};

imperial = {};

module.exports = {
  metric: metric,
  imperial: imperial,
  _anchors: {
    metric: {
      unit: 'mW/cm²',
      ratio: 1,
    },
    imperial: {
      unit: 'mW/cm²',
      ratio: 1,
    },
  },
};
